import "../Main.css";
import { useEffect, useState } from "react";
import ProductSolutionCard from "../../components/ProductSolutionCard";
import ProductAndSolution from "./ProductAndSolution";
import { getProduct, getProductTitle } from "../../services/ProductAPI";

export const Product = () => {
    const [cardList, setCardList] = useState([]);
    const [titleImage, setTitleImage] = useState();
    const [titleText, setTitleText] = useState();

    useEffect(() => {
        getProductTitle().then((result) => {
            setTitleImage(result.imageUrl);
            setTitleText(result.name);
        });

        getProduct().then((result) => {
            let cards = [];
            result.map((product, index) => {
                cards.push(
                    <ProductSolutionCard
                        key={index}
                        image={product["imageURL"]}
                        name={product["name"]}
                        id={product["productID"]}
                        type={product["type"]}
                        selected_page={6}
                    />
                );
            });
            setCardList(cards);
        });
    }, []);

    return <ProductAndSolution titleImage={titleImage} titleText={titleText} cardList={cardList} selected_page={6} />;
};
